import React, {
  createRef,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import PropTypes from "prop-types";
import { ReactComponent as TrashSvg } from "../../../assets/icons/trash.svg";

const prefix = "new-project-work-exchange-upload-file";

function FileUpload({ file, handleRemoveFile, isDelete, newDownload }) {
  const [isProgress, setIsProgress] = useState(newDownload);
  const [progress, setProgress] = useState(0);

  // TODO: Change Icon
  // const resolveIcon = (typeImage) => {
  //   switch (typeImage) {
  //     case "image/jpeg":
  //       return "https://media.discordapp.net/attachments/1212798445539299350/1230940848535896175/image.png?ex=66289fc0&is=66274e40&hm=7ab207e52a7814bf18b619238b861713d833e4ed6df23a5082b12a02951369ce&=&format=webp&quality=lossless&width=576&height=576";
  //     case "image/png":
  //       return "https://media.discordapp.net/attachments/1212798445539299350/1230941194129772695/image.png?ex=66352652&is=6622b152&hm=45ee91b9c1d0ec031c4118f7afbac369af80b3db833587a559ea9bb3be74fdf6&=&format=webp&quality=lossless&width=576&height=576";
  //     case "application/pdf":
  //       return "https://media.discordapp.net/attachments/1212798445539299350/1230940972351885373/image.png?ex=6635261d&is=6622b11d&hm=a6f7b2195de75f26f85bd83fb0eb334ed0dc0b481581d57ef03e94d323c39b3c&=&format=webp&quality=lossless&width=576&height=576";
  //     default:
  //   }
  // };

  useEffect(() => {
    if (isProgress) {
      setProgress(0);
      setInterval(() => {
        setProgress((prevProgress) =>
          prevProgress >= 100 ? 100 : prevProgress + 1
        );
      }, 10);
    } else {
      setProgress(0);
    }

    setTimeout(() => {
      setIsProgress(false);
    }, 1200);
  }, [isProgress, file]);

  return (
    <>
      <div className={`${prefix}-container`}>
        <div className={`${prefix}-container-file`}>
          {/* <div className={`${prefix}-container-file-icon`}>
            <img src={resolveIcon(file.mimeType || file.type)} />
            {resolveIcon(file.mimeType || file.type)}
          </div> */}
          <div className={`${prefix}-container-file-wrp`}>
            <div className={`${prefix}-container-file-wrp-detail`}>
              <div className={`${prefix}-container-file-wrp-detail__name`}>
                {file.name}
              </div>
              {isDelete && (
                <div className={`${prefix}-container-file-wrp-detail-delete`}>
                  <TrashSvg
                    className={`${prefix}-container-file-wrp-detail-delete__trash`}
                    onClick={() => handleRemoveFile(file)}
                  />
                </div>
              )}
            </div>
            {isProgress && (
              <div className={`${prefix}-container-progress`}>
                <div
                  className={`${prefix}-container-progress-inner`}
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

FileUpload.propTypes = {};

export default FileUpload;
